import { render, staticRenderFns } from "./WealthProductWithdraw.vue?vue&type=template&id=4c92f026&scoped=true&"
import script from "./WealthProductWithdraw.vue?vue&type=script&lang=ts&"
export * from "./WealthProductWithdraw.vue?vue&type=script&lang=ts&"
import style0 from "./WealthProductWithdraw.vue?vue&type=style&index=0&id=4c92f026&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c92f026",
  null
  
)

export default component.exports